export const FEATURES = [
  {
    name: "bundles",
    displayName: "Bundles",
    hasSettings: false,
  },
  {
    name: "insights",
    displayName: "Insights",
    hasSettings: true,
  },
  {
    name: "smartify",
    displayName: "Smartify",
    hasSettings: false,
  },
  {
    name: "stories",
    displayName: "Stories",
    hasSettings: true,
  },
  {
    name: "readingtime",
    displayName: "Reading Time",
    hasSettings: true,
  },
  {
    name: "tentacles",
    displayName: "Tentacles",
    hasSettings: true,
  },
  {
    name: "videos",
    displayName: "Videos",
    hasSettings: true,
  },
  {
    name: "waves",
    displayName: "Waves",
    hasSettings: true,
  },
  {
    name: "goals",
    displayName: "Goals",
    hasSettings: false,
  },
  {
    name: "recommender",
    displayName: "Recommender",
    hasSettings: false,
  },
  {
    name: "landingPages",
    displayName: "Landing Pages",
    hasSettings: false,
  },
  {
    name: "ai",
    displayName: "smartocto.ai",
    hasSettings: true,
  },
  {
    name: "custommetrics",
    displayName: "Custom Metrics",
    hasSettings: true,
  },
  {
    name: "channeloptimalisation",
    displayName: "Channel Optimalisation",
    hasSettings: true,
  },
  {
    name: "articlevalue",
    displayName: "Article Value",
    hasSettings: true,
  },  
  {
    name: "user_needs",
    displayName: "User Needs",
    hasSettings: false,
  }  
];
